module.exports = __webpack_public_path__ + "media/flags/en-e2dd338d.svg";